import { render, staticRenderFns } from "./SetVisaPrice.vue?vue&type=template&id=d581c5f8"
import script from "./SetVisaPrice.vue?vue&type=script&lang=js"
export * from "./SetVisaPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports